import BpkText from '@skyscanner/backpack-web/bpk-component-text';

import type { ImagesGalleryItem } from '../../../types';

import STYLES from '../MediaWall.module.scss';

import { VIDEOS_CATEGORY } from '@hotels-hotel-detail/utils/hotel-images';
import PlayOverlay from '@shared/ui/common/PlayOverlay';
import ProgressivePictureButton from '@shared/ui/common/ProgressivePictureButton';
import TRAVELLER_INFO from '@shared/ui/components/TravellerInfoMapping';

type Props = {
  item: ImagesGalleryItem;
  index: number;
  toggleView: (index: number) => void;
};

const ImageItem = ({ index, item, toggleView }: Props) => {
  const { category, guestType, src, thumbnail, travelInfo } = item;
  let overlay = null;
  const imageUrl = thumbnail ?? src;

  if (category === VIDEOS_CATEGORY) {
    overlay = (
      <PlayOverlay
        onClick={() => {
          toggleView(index);
        }}
      />
    );
  } else if (travelInfo && guestType) {
    const Icon = TRAVELLER_INFO[guestType] && TRAVELLER_INFO[guestType].icon;
    if (Icon) {
      overlay = (
        <section className={STYLES.MediaWall__travellerInfo}>
          <div
            style={{
              backgroundColor: TRAVELLER_INFO[guestType]
                ? TRAVELLER_INFO[guestType].backgroundColor
                : 'none',
            }}
            className={STYLES.MediaWall__iconContainer}
          >
            <Icon />
          </div>
          <BpkText tagName="p">{travelInfo}</BpkText>
        </section>
      );
    }
  }

  return (
    <>
      <ProgressivePictureButton
        dataTestId="media-wall-item"
        className={STYLES.MediaWall__item}
        sources={[
          {
            media: '(max-width: 1200px)',
            srcSet: [
              `${imageUrl.replace('_WxH', `_320x320`)} 320w`,
              `${imageUrl.replace('_WxH', `_480x480`)} 480w`,
              `${imageUrl.replace('_WxH', `_640x640`)} 640w`,
              `${imageUrl.replace('_WxH', `_960x960`)} 960w`,
            ],
          },
          {
            media: '(min-width: 1201px)',
            srcSet: [
              `${imageUrl.replace('_WxH', `_320x192`)} 320w`,
              `${imageUrl.replace('_WxH', `_480x288`)} 480w`,
              `${imageUrl.replace('_WxH', `_640x384`)} 640w`,
              `${imageUrl.replace('_WxH', `_960x576`)} 960w`,
            ],
          },
        ]}
        alt=""
        src={imageUrl}
        lazyLoad
        onClick={() => {
          toggleView(index);
        }}
      />
      {overlay}
    </>
  );
};

export default ImageItem;
